// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"FilterHeading_headingWrapper__1GHek","levelModalButton":"FilterHeading_levelModalButton__8O3uW"};